import { Inject, Injectable, Injector } from "@angular/core";
import { L10nIntlService, L10nLoader, L10nLocale, L10nTranslationService, L10N_LOCALE } from "angular-l10n";
import { Subject, forkJoin, lastValueFrom, tap, map } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { AppStartupHttpService } from "app/app-startup-http.service";
import { DataSharedService } from "./app-web/app-global/services/data-shared.service";
import * as moment from "moment";
import { SubscriptionEnum } from "./app-web/app-model/enum/common/subscription.enum";
import { switchMap } from 'rxjs/operators';
import { TranslationPipe } from "./app-web/app-core/translation/translation.pipe";

@Injectable()
export class AppStartupService {

    // Observable's unsubscribe
    private unsubscribe = new Subject<void>();

    private router: Router;

    constructor( private injector: Injector, private appStartupHttpService: AppStartupHttpService,
        private translationService: L10nTranslationService, private dataSharedService: DataSharedService, @Inject(L10N_LOCALE) public localeService: L10nLocale,
		private locale: L10nIntlService,  public l10nLoader: L10nLoader, private route: ActivatedRoute, private translationPipe: TranslationPipe ) {
    }

	initializeApp() {
		this.setDefaultUserLocale();
        this.setOauth2Token();
		return new Promise(async (resolve, reject) => {
			try {
				this.router = this.injector.get(Router);
				const userInfos = await lastValueFrom(this.getUserInfos());
				this.dataSharedService.appId = userInfos.medicalOffice.appId;
				this.dataSharedService.appCountryCode = userInfos.medicalOffice.appCountryCode;
				this.dataSharedService.appSubscription = SubscriptionEnum.getSubscriptionByName(userInfos.medicalOffice.subscription);
				localStorage.setItem('medicalOffice', JSON.stringify(userInfos.medicalOffice));
				localStorage.setItem('user', JSON.stringify(userInfos.user));
				const token = 'Bearer ' + userInfos.refreshApp;
				sessionStorage.setItem('token', token);
				this.setUserLocale(userInfos);
				await lastValueFrom(
					forkJoin([
						this.getAuthorityList(),
						this.getAppointmentTypeList()
					]).pipe(
						tap(([authorityList, appointmentTypeList]) => {
							if (!Array.isArray(authorityList)) authorityList = [];
							if (!Array.isArray(appointmentTypeList)) appointmentTypeList = [];
							this.dataSharedService.authorityList = authorityList;
							this.dataSharedService.appointmentSettings.appointmentTypeList = appointmentTypeList;
						}),
						map(() => true)
					)
				);
				resolve(true);
			} catch (error) {
				console.error('Erreur dans initializeApp:', error);
				if (error?.status == 401 && error?.url?.includes("/getUserInfos")) {
					resolve(true);
				} else {
					console.error('Erreur :', error);
                    resolve(false);
				}
			}
		});
	}


    /********************************************
     * ******************************************
     * User
     * ******************************************
     ********************************************/

    /**
     * get the User informations
     */
    getUserInfos() {
        return this.appStartupHttpService.getUserInfos();
    }

    /**
     * set the oauth2 token
     */
    setOauth2Token() {
        let url = window.location.hash;
        if (url.includes('/oauth2Connect?')) {
            let queryString = url.split('?')[1];
            let hashParams = new URLSearchParams(queryString);
            let token = hashParams.get('token');
            let username = hashParams.get('username');
            let medicalOffice = hashParams.get('medicalOffice');
            if (token != undefined && token != null && token != "") {
                token = 'Bearer ' + token;
                sessionStorage.setItem( 'token', token );
                sessionStorage.setItem( 'username', username );
                localStorage.setItem( 'medicalOfficeCode', medicalOffice );
                let appIdResult = medicalOffice?.startsWith("gyn-") ? 2 : 1;
                localStorage.setItem( 'appId', JSON.stringify(appIdResult) );
            } else {
                let error = hashParams.get('error');
                if (error != undefined && error != null && error != "") {
                    alert("This user is not affiliated with any medical office. Please proceed with the registration.");
                } else {
                    alert("Error!");
                }
            }
        }
    }
    
    /**
     * set the default locale of User
     */
    setDefaultUserLocale() {
        let userLocale: string;
        let userLocaleLocalStorage = localStorage.getItem( 'defaultLocale' );
        if ( userLocaleLocalStorage != undefined && userLocaleLocalStorage != null ) {
            userLocale = userLocaleLocalStorage;
        } else {
            userLocale = navigator.language;
        }
		this.translationService.setLocale(undefined);
        this.translationService.setLocale( { language: userLocale, dateLanguage: userLocale, numberLanguage: userLocale, currency: undefined, timeZone: 'UTC' } );
    }

    /**
     * set locale of User
     */
    setUserLocale( data: any ) {
        let userLocale: string = data.medicalOffice.locale;
		localStorage.setItem( 'defaultLocale', userLocale );
		this.translationService.setLocale(undefined);
        this.translationService.setLocale( { language: userLocale, dateLanguage: userLocale, numberLanguage: userLocale, currency: undefined, timeZone: 'UTC' } );
		moment.locale(userLocale);
    }


    /********************************************
     * ******************************************
     * After Authentication
     * ******************************************
     ********************************************/

    /**
     * get the list of authorities
     */
    getAuthorityList() {
        return this.appStartupHttpService.getAuthorityList();
    }

	/**
     * get the AppointmentType list
     */
    getAppointmentTypeList() {
        return this.appStartupHttpService.getAppointmentTypeList();
	}

}
